import { APICore } from 'src/helpers/api/apiCore';
import config from 'src/config';
const apiBaseUrl = config.API_URL;
const api = new APICore();

// add test Panel Mapping
function creatTestPanelMapping(Panels: any) {
    const baseUrl = `/pnlpkgMap/createPnlMap`;
    return api.create(`${baseUrl}`, Panels);
}
// update Test Panel Mapping
function updateTestPanelMapping(Panels: any) {
    const baseUrl = '/pnlpkgMap/updPnlMap';
    return api.update(`${baseUrl}`, Panels);
}

// get all test Panel Mappings
function getAllTestPanelMapping(Panels: any) {
    const baseUrl = '/pnlpkgMap/fetchAllMap';
    return api.create(`${baseUrl}`, Panels);
}

// get test Panel Mapping
function getTestPanelMapping(Panels: any) {
    const baseUrl = '/pnlpkgMap/getMapInfo';
    return api.create(`${baseUrl}`, Panels);
}

// get test Panel Listing
function getTestPanelsListing(Panels: any) {
    const baseUrl = '/pnlpkgMap/getPanels';
    return api.create(`${baseUrl}`, Panels);
}

export {
    creatTestPanelMapping,
    updateTestPanelMapping,
    getAllTestPanelMapping,
    getTestPanelMapping,
    getTestPanelsListing,
};
